import { Component, ViewChild } from '@angular/core';
import ExpandMenu from '../../../../assets/data/expanded-menu.json'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonWithTextMenuComponent } from "../../../shared/components/button-with-text-menu/button-with-text-menu.component";
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { ConceptUtilsService } from '@shared/services/concept-utils/concept-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
  selector: 'published-concept-modal',
  templateUrl: './published-concept-modal.component.html',
  standalone: true,
  imports: [
    ButtonWithTextMenuComponent,
    SpanTooltipComponent,
    AfTranslatePipe
  ]
})
export class PublishedConceptModalComponent {
  configuration: any = this.dialogConfig.data;
  publishedConceptModal: any = {
    shareUrlItem: {expandedMenu: ExpandMenu['menuShareUrl'].menu},
  }
  constructor(private dialogRef: DynamicDialogRef<PublishedConceptModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private conceptUtilsService: ConceptUtilsService) { }
  @ViewChild(ButtonWithTextMenuComponent) buttonWithTextMenu: ButtonWithTextMenuComponent;

  launchActionLink(option: any){
    let configuration: any = {
      evaluationId: this.configuration.evaluationId,
      conceptId: this.configuration.concept.conceptId,
      text: this.configuration.concept.url,
      action: option.action,
      buttonCopyTooltip: this.buttonWithTextMenu,
      typeButtonTooltip: 'buttonWithTextMenu',
      time: 2000
    }
    this.conceptUtilsService.selectOptionsLink(configuration);
    if(option.action !== 'copyLink'){
      this.handleAccept(option.action);
    }
  }

  handleAccept(result: string = 'ok') {
    this.dialogRef.close({ result: result });
  }
}
